// predefinedResponses.ts
export interface PredefinedResponse {
  id: string;
  patterns: RegExp[]; // 정규 표현식 패턴
  keywords?: string[]; // 추가 키워드 (선택 사항)
  response: string;
}

export const predefinedResponses: PredefinedResponse[] = [
  // 1. 스토어 개요
  {
    id: 'store_overview',
    patterns: [
      /^CREAIT 마인크래프트 리소스 스토어에 대해 알려줘$/,
      /^스토어가 뭐야$/,
      /^CREAIT 스토어는 무슨 곳이야$/,
      /^CREAIT 스토어 개요$/,
      /^CREAIT 스토어가 뭔지 설명해줘$/,
    ],
    keywords: ['스토어', 'CREAIT 스토어', 'CREAIT 마인크래프트'],
    response: "CREAIT 마인크래프트 리소스 스토어는 전 세계 마인크래프트 크리에이터들이 창작한 디지털 리소스(맵, 텍스처, 스킨, 플러그인 등)를 판매하고 구매할 수 있는 글로벌 마켓플레이스입니다. 이 스토어는 크리에이터들에게 새로운 수익 창출 기회를 제공하며, 마인크래프트 플레이어들에게는 독창적인 콘텐츠를 손쉽게 발견하고 구매할 수 있는 공간을 제공합니다.",
  },

  // 2. 회원가입 및 판매자 등록
  {
    id: 'membership_registration',
    patterns: [
      /^CREAIT 스토어에 어떻게 회원가입 해$/,
      /^회원가입 방법 알려줘$/,
      /^CREAIT 스토어에 회원가입은 어떻게 해$/,
      /^판매자 되려면 어떻게 해야 해$/,
      /^판매자 등록 절차가 어떻게 되나요$/,
      /^CREAIT에서 판매자가 되려면 어떻게 해야 해$/,
    ],
    keywords: ['회원가입', '판매자 등록', '판매자가 되는 방법'],
    response: "CREAIT 스토어에서 판매 활동을 하기 위해서는 CREAIT 플랫폼에 회원가입 후, 판매자 등록 절차를 완료해야 합니다. 회원가입은 CREAIT 웹사이트 또는 모바일 앱을 통해 간단한 절차로 진행할 수 있습니다. 판매자 등록 시 크리에이터 정보와 결제 정보를 제공하고, 약관에 동의해야 합니다. 또한, 콘텐츠 업로드 전 CREAIT의 적합성 검토를 거쳐야 하며, 마인크래프트 관련 저작권 및 이용 정책을 준수해야 합니다.",
  },

  // 3. 콘텐츠 가격 책정
  {
    id: 'pricing',
    patterns: [
      /^콘텐츠 가격은 어떻게 정해져$/,
      /^가격 책정 기준 알려줘$/,
      /^CREAIT 스토어에서 콘텐츠 가격을 어떻게 설정해$/,
      /^할인 적용은 어떻게 돼$/,
      /^스토어에서 판매하는 콘텐츠 가격은 어떻게 결정돼$/,
      /^콘텐츠 가격 설정 방법이 궁금해$/,
    ],
    keywords: ['가격 책정', '콘텐츠 가격', '할인', '프로모션'],
    response: "CREAIT 스토어에서 판매되는 모든 콘텐츠의 가격은 판매자가 직접 결정합니다. 가격 책정 시 다음 사항을 고려해야 합니다:\n1. **콘텐츠의 품질과 시장 가치 반영**: 유사한 콘텐츠와의 가격 비교를 통해 적정가를 설정합니다.\n2. **할인 및 프로모션**: 크리에이터는 자신의 콘텐츠에 대해 기간 한정 할인이나 프로모션을 설정할 수 있습니다.\n3. **가격 투명성**: 모든 가격은 세금 포함 기준으로 표시되며, 추가 요금은 발생하지 않습니다.",
  },

  // 4. 구매 및 다운로드
  {
    id: 'purchase_download',
    patterns: [
      /^CREAIT 스토어에서 어떻게 구매해$/,
      /^콘텐츠 다운로드는 어떻게 해$/,
      /^결제 방법이 뭐야$/,
      /^콘텐츠를 다운로드한 후 환불 받을 수 있어$/,
      /^스토어에서 구매한 콘텐츠는 어떻게 다운로드해$/,
      /^CREAIT 스토어에서 결제는 어떻게 이루어져$/,
    ],
    keywords: ['구매', '다운로드', '결제', '환불'],
    response: "CREAIT 스토어에서 콘텐츠를 구매하려면 원하는 콘텐츠를 선택하고 결제하시면 됩니다. 결제 수단으로는 신용카드, 전자지갑 등 다양한 옵션이 지원됩니다. 결제 완료 후 즉시 콘텐츠를 다운로드하거나 사용 권한을 얻게 됩니다. 다만, 환불 정책에 따라 다운로드 후에는 환불이 제한될 수 있으니 구매 전에 환불 정책을 확인해 주세요.",
  },

  // 5. 수수료 정책
  {
    id: 'fee_policy',
    patterns: [
      /^CREAIT 스토어의 수수료는 얼마야$/,
      /^수수료 구조 알려줘$/,
      /^판매 시 수수료는 어떻게 돼$/,
      /^수수료 감소 조건이 뭐야$/,
      /^스토어 수수료 정책 좀 알려줘$/,
      /^콘텐츠 판매 시 어떤 수수료가 부과돼요$/,
    ],
    keywords: ['수수료', '판매 수수료', '수수료 정책', '수수료 감소'],
    response: "CREAIT 스토어는 판매된 콘텐츠에 대해 일정한 수수료를 부과합니다. 기본적으로 모든 콘텐츠 판매에 대해 판매 금액의 **10%**가 수수료로 부과됩니다. 하지만, 활동이 우수한 크리에이터를 위한 수수료 단계 감소 제도가 마련되어 있습니다:\n- **1단계**: 기본 수수료 10%\n- **2단계**: 월간 판매량 및 콘텐츠 품질 평가 기준을 충족할 경우 8%로 감소\n- **3단계**: 지속적인 성과를 낼 경우 6%로 추가 감소\n- **최종 단계**: ‘크릿 작업자’ 등급을 획득하면 수수료가 최대 5%까지 감소됩니다.",
  },

  // 6. 크리에이터 등급 시스템
  {
    id: 'creator_grading_system',
    patterns: [
      /^크리에이터 등급 시스템에 대해 알려줘$/,
      /^CREAIT 크리에이터 등급이 뭐야$/,
      /^크리에이터 등급은 어떻게 올라가$/,
      /^등급에 따른 혜택이 뭐야$/,
      /^CREAIT 파트너 등급 시스템 설명해줘$/,
      /^크리에이터 등급 유지 방법이 궁금해$/,
    ],
    keywords: ['등급 시스템', '크리에이터 등급', '파트너 등급', '혜택'],
    response: "CREAIT 스토어는 창작자의 성장을 지원하기 위해 **크리에이터 등급 시스템**을 도입했습니다. 크리에이터는 판매 실적, 콘텐츠 품질, 커뮤니티 기여도 등을 기준으로 자동으로 등급이 상승하며, 상위 등급일수록 더 많은 혜택을 받을 수 있습니다.\n\n**등급 구조**:\n1. **일반 크리에이터**: 처음 판매를 시작하는 모든 사용자에게 적용되는 기본 등급입니다.\n2. **상위 크리에이터**: 판매 실적과 작품 품질에 따라 자동으로 승급되며, 더 많은 혜택이 주어집니다.\n3. **크릿 작업자**: 상위 크리에이터가 추가적인 회사 측의 심사를 거쳐 '크릿 작업자'로 승급됩니다. 이 등급을 획득하면 수수료 감면, 우선 노출 등 다양한 혜택을 받을 수 있습니다.\n\n**등급 상승 기준**:\n- **1~3단계 승급**: 월간 판매량 및 작품 품질 평가 기준을 충족할 경우 자동 승급됩니다.\n- **크릿 작업자 승급**: 3단계를 달성한 후 CREAIT 팀의 추가 심사를 통해 결정됩니다.\n\n**CREAIT 파트너 프로그램**의 등급 시스템을 통해 크리에이터는 지속적으로 성장하고 다양한 혜택을 누릴 수 있습니다.",
  },

  // 7. 저작권 및 규제 준수
  {
    id: 'copyright_compliance',
    patterns: [
      /^콘텐츠 업로드 시 저작권은 어떻게 해야 해$/,
      /^저작권 침해되면 어떻게 돼$/,
      /^저작권 및 이용 정책을 어떻게 준수해$/,
      /^CREAIT 스토어의 규제는 뭐야$/,
      /^저작권 정책에 대해 자세히 알려줘$/,
      /^콘텐츠 저작권 보호 방법이 뭐야$/,
      /^저작권 침해하면 어떻게 돼$/,
      /^CREAIT 저작권 정책 설명해줘$/,
      /^저작권 문제 발생 시 대응 방법이 궁금해$/,
    ],
    keywords: ['저작권', '저작권 준수', '규제 준수', '저작권 침해', '콘텐츠 규제'],
    response: "CREAIT 스토어에 업로드된 모든 콘텐츠는 저작권법 및 마인크래프트 사용자 정책을 준수해야 합니다. 타인의 저작물을 무단으로 업로드하거나 사용하는 것은 금지됩니다. 저작권 침해가 확인될 경우, 법적 조치가 취해질 수 있으며, 콘텐츠가 반려되거나 계정이 정지될 수 있습니다.\n\n**저작권 침해 금지**: 타인의 저작물을 무단으로 업로드할 경우 법적 조치가 취해질 수 있습니다.\n**CREAIT의 심사 절차**: 모든 콘텐츠는 등록 전 CREAIT의 심사 절차를 거칩니다. 이 과정에서 부적합한 콘텐츠는 반려될 수 있습니다.\n\n**저작권 보호**: 크리에이터는 자신의 콘텐츠에 대한 저작권을 보호하기 위해 적절한 조치를 취해야 합니다. 예를 들어, 워터마크 추가, 저작권 표시 등을 통해 자신의 작품을 보호할 수 있습니다.",
  },

  // 8. 커뮤니티 소통 및 지원
  {
    id: 'community_support',
    patterns: [
      /^커뮤니티에서 어떻게 소통해$/,
      /^지원은 어떻게 받아$/,
      /^디스코드 채널은 뭐야$/,
      /^커뮤니티에서 제공하는 기능이 뭐야$/,
      /^CREAIT 커뮤니티는 어떻게 운영돼$/,
      /^커뮤니티 지원 안내 좀 해줘$/,
      /^커뮤니티 소통 방법이 뭐야$/,
    ],
    keywords: ['커뮤니티', '소통', '지원', '디스코드', '피드백'],
    response: "CREAIT 스토어는 **디스코드** 및 다양한 커뮤니티 채널을 통해 크리에이터와 사용자 간의 소통을 지원합니다. 커뮤니티에서 제공되는 기능은 다음과 같습니다:\n- **스토어 관련 질문 및 답변 제공**\n- **창작물 피드백 및 아이디어 공유**\n- **개발자와 직접 소통 가능한 공간 마련**\n- **이벤트 및 공지사항 안내**\n\n이 외에도 커뮤니티를 통해 유익한 정보와 피드백을 나누며, 함께 성장하는 환경을 구축하고자 합니다.",
  },

  // 9. 문의 및 지원 안내
  {
    id: 'inquiry_support',
    patterns: [
      /^문의는 어떻게 해$/,
      /^지원이 필요해$/,
      /^고객 지원 이메일이 뭐야$/,
      /^지원팀에 연락하는 방법이야$/,
      /^CREAIT 지원팀 연락처 알려줘$/,
      /^문의 방법 알려줘$/,
      /^고객 지원 방법이 궁금해$/,
    ],
    keywords: ['문의', '지원', '고객 지원', '연락 방법'],
    response: "스토어 이용 중 궁금한 점이 있거나 문제가 발생한 경우, CREAIT 지원팀에 문의해 주세요.\n\n**문의 이메일**: sj@cnitsstudio.com\n**디스코드 채널**: [디스코드 초대 링크](https://discord.gg/SbSCD7NXSY)\n\nCREAIT는 크리에이터의 성공을 돕기 위해 언제나 최선을 다하고 있습니다.",
  },

  // 📜 환불 정책 세부 안내
  // 1. 환불이 가능한 경우
  {
    id: 'refund_available',
    patterns: [
      /^환불이 가능한 경우는 뭐야$/,
      /^어떤 상황에서 환불 받을 수 있어$/,
      /^파일 결함이 있을 때 환불 가능해$/,
      /^중복 결제하면 환불 받을 수 있어$/,
      /^환불 가능한 사유가 뭐야$/,
      /^환불 받을 수 있는 경우 알려줘$/,
      /^환불 가능한 상황이 뭐야$/,
    ],
    keywords: ['환불 가능', '환불 사유', '파일 결함', '중복 결제'],
    response: "CREAIT 스토어에서는 다음과 같은 예외적인 상황에서만 환불이 가능합니다:\n\n1. **파일에 치명적인 결함이 있는 경우**: 구매한 콘텐츠가 명백한 오류를 포함하거나 파일이 손상되어 제대로 작동하지 않을 경우 환불이 가능합니다. 예를 들어, 파일 형식 오류나 전혀 작동하지 않는 경우가 이에 해당됩니다.\n\n2. **잘못된 결제 또는 중복 결제**: 실수로 동일한 콘텐츠를 여러 번 결제한 경우, 또는 결제 과정에서 오류가 발생하여 잘못된 금액이 청구된 경우, 구매 후 48시간 이내에 고객 지원팀에 문의해 주시면 환불이 가능합니다. 중복 결제의 경우, 최초 구매 외의 중복 결제에 대해서만 환불이 처리됩니다.",
  },

  // 2. 환불이 불가능한 경우
  {
    id: 'refund_unavailable',
    patterns: [
      /^환불이 안 되는 경우는 뭐야$/,
      /^두 번 결제하면 환불 할 수 없었어$/,
      /^단순 변심으로는 환불 되지 않아$/,
      /^콘텐츠 다운로드 후 환불 받을 수 없어$/,
      /^기술적 요구 사항 때문에 환불 안 돼$/,
      /^이용 가이드 못 보니까 환불 안 돼$/,
      /^환불이 되지 않는 경우 알려줘$/,
      /^환불 불가 상황이 뭐야$/,
      /^환불이 안 되는 사유가 뭐야$/,
    ],
    keywords: ['환불 불가', '단순 변심', '다운로드 후', '기술 요구', '이용 가이드'],
    response: "CREAIT 스토어의 모든 콘텐츠는 디지털 파일로 제공되므로, 다음과 같은 경우에는 환불이 불가능합니다:\n\n1. **콘텐츠가 정상적으로 다운로드 및 사용된 경우**: 구매한 콘텐츠가 성공적으로 다운로드되고, 파일에 문제가 없는 경우에는 환불이 불가합니다. 사용자는 구매와 동시에 디지털 파일에 대한 접근 권한을 얻기 때문에, 다운로드 후 환불을 요청할 수 없습니다.\n\n2. **단순 변심**: 사용자가 콘텐츠를 구매한 후 개인적인 이유로 더 이상 사용하지 않거나 마음이 바뀌는 경우에는 환불이 불가합니다. 구매 전에 콘텐츠 설명을 충분히 검토하시고 구매 결정을 내려주시기 바랍니다.\n\n3. **기술적 요구 사항 미충족**: 콘텐츠가 정상적으로 작동하지만, 사용자의 장치 또는 소프트웨어가 콘텐츠의 기술적 요구 사항을 충족하지 못해 발생하는 문제는 환불 사유에 해당하지 않습니다. 예를 들어, 시스템 호환성이 맞지 않거나 파일이 제대로 실행되지 않는 경우, 이는 환불이 불가합니다.\n\n4. **이용 가이드 미숙지**: 콘텐츠에 포함된 이용 가이드를 충분히 숙지하지 않아 발생한 문제는 환불이 불가합니다. 구매자는 제공되는 설명 및 가이드를 따라 콘텐츠를 활용해야 하며, 이에 대한 책임은 구매자에게 있습니다.",
  },

  // 📩 환불 절차 안내
  {
    id: 'refund_process',
    patterns: [
      /^환불 절차는 어떻게 돼$/,
      /^환불 요청하려면 어떻게 해$/,
      /^환불 신청 방법 알려줘$/,
      /^환불을 받고 싶어 어떻게 해야 해$/,
      /^환불 절차를 설명해줘$/,
      /^환불 요청 절차는 무엇이야$/,
      /^환불 신청 절차 알려줘$/,
      /^환불을 신청하려면 어떻게 해야 해$/,
    ],
    keywords: ['환불 절차', '환불 신청', '환불 요청'],
    response: "환불이 가능한 상황에 해당한다고 판단되면, 다음 절차에 따라 환불 요청을 진행할 수 있습니다. 신속하고 정확한 처리를 위해 필요한 정보를 정확히 기입해 주세요:\n\n1. **구매한 콘텐츠의 이름**: 환불을 요청하는 콘텐츠의 정확한 이름을 기재해 주세요. 이는 고객 지원팀이 환불 요청을 확인하는 데 필수적인 정보입니다.\n\n2. **구매 일자 및 결제 영수증**: 구매 날짜와 함께 결제 영수증(이메일 확인 또는 구매 이력 스크린샷)을 제공해 주세요. 이를 통해 결제가 제대로 이루어졌는지 확인할 수 있습니다.\n\n3. **주문 번호**: 주문 번호는 결제 시 발송된 이메일 또는 계정 내 구매 이력에서 확인할 수 있습니다. 이 번호는 환불 요청 처리를 위한 중요한 정보입니다.\n\n4. **환불 요청 사유**: 환불을 요청하는 이유를 구체적으로 설명해 주세요. 파일 결함, 중복 결제 등의 사유에 대한 명확한 설명이 필요합니다. 파일 문제의 경우, 문제를 보여주는 스크린샷 또는 오류 메시지를 첨부해 주시면 처리가 빨라집니다.\n\n**환불 요청 접수처**: 환불 요청은 CREAIT 고객 지원팀에 이메일로 접수해 주세요.\n● 이메일 주소: support@creaitstore.com\n\n고객 지원팀은 요청을 받은 후, 3-5 영업일 이내에 검토를 마치고 환불 가능 여부를 안내해 드립니다. 환불이 승인되면, 결제하신 원 결제 수단으로 환불이 처리됩니다.",
  },

  // 🔍 구매 전 유의사항
  {
    id: 'purchase_before_caution',
    patterns: [
      /^구매 전에 주의할 점이 뭐야$/,
      /^구매 전 유의사항 알려줘$/,
      /^콘텐츠 구매 전에 확인해야 할 게 뭐야$/,
      /^구매 전에 꼭 봐야 할 사항이야$/,
      /^콘텐츠 구매 전 주의사항이 있나요$/,
      /^구입 전에 알아야 할 점 알려줘$/,
      /^콘텐츠 구매 전에 해야 할 일이 뭐야$/,
    ],
    keywords: ['구매 전 주의사항', '유의사항', '콘텐츠 확인', '시스템 요구사항'],
    response: "환불이 제한적인 만큼, 콘텐츠 구매 전 다음 사항을 꼭 확인해 주세요:\n\n1. **콘텐츠 설명 및 리뷰 확인**: 구매 전 콘텐츠 설명을 자세히 읽고, 제공되는 기능 및 파일 내용이 기대에 부합하는지 확인하세요. 시스템 요구 사항, 기능 설명 등을 충분히 검토한 후 구매 결정을 내려주시기 바랍니다. 또한, 다른 사용자의 리뷰를 참고하여 콘텐츠의 품질과 신뢰성을 확인할 수 있습니다.\n\n2. **기술적 요구 사항 확인**: 콘텐츠를 원활하게 사용하기 위해서는 해당 콘텐츠가 지원하는 시스템 및 소프트웨어 요구 사항을 충족해야 합니다. 콘텐츠 설명에 명시된 기술적 요구 사항을 반드시 확인해 주세요. 사용자의 장치 또는 소프트웨어가 콘텐츠의 요구 사항을 충족하지 못할 경우, 환불이 불가능합니다.\n\n3. **평가판 또는 무료 콘텐츠 사용 권장**: 일부 콘텐츠는 무료 평가판 또는 샘플을 제공할 수 있습니다. 구매 전에 평가판을 사용해 보거나, 무료로 제공되는 콘텐츠를 통해 콘텐츠의 품질과 기능을 미리 체험해 보시는 것을 권장합니다.",
  },

  // CREAIT 파트너 프로그램 가이드 및 혜택
  // 1. 파트너 프로그램 개요
  {
    id: 'partner_program_overview',
    patterns: [
      /^CREAIT 파트너 프로그램이 뭐야$/,
      /^파트너 프로그램에 대해 설명해줘$/,
      /^CREAIT 파트너 프로그램 개요$/,
      /^파트너 프로그램 이점이 뭐야$/,
      /^파트너 프로그램이 무엇인지 알려줘$/,
      /^CREAIT 파트너 프로그램 소개해줘$/,
    ],
    keywords: ['파트너 프로그램', '파트너 선정', '혜택', '성장 지원'],
    response: "CREAIT 파트너 프로그램은 창작자들이 플랫폼 내에서 더 큰 성장을 이루고, 추가적인 혜택을 누릴 수 있도록 마련된 제도입니다. 파트너로 선정된 크리에이터는 플랫폼의 핵심 일원이 되어 다양한 지원을 받으며, 더 넓은 고객층과 연결될 수 있는 기회를 얻게 됩니다.\n\n**파트너 프로그램 개요**:\n- **파트너 선정 기준**: 콘텐츠 품질, 판매 실적, 커뮤니티 기여도, 업데이트 및 유지 관리 등 다양한 기준을 충족해야 합니다.\n- **심사 절차**: 초기 자동 평가 후, CREAIT 팀의 수동 심사와 최종 인터뷰를 통해 파트너를 선정합니다.\n- **혜택**: 스토어 내 우선 노출, 마케팅 지원, 수수료 혜택, 콘텐츠 업데이트 지원, 전문 워크샵 참여 기회 등 다양한 혜택을 제공합니다.",
  },

  // 2. 파트너 프로그램 혜택
  {
    id: 'partner_benefits',
    patterns: [
      /^CREAIT 파트너 혜택이 뭐야$/,
      /^파트너로 되면 어떤 혜택을 받아$/,
      /^파트너 혜택 설명해줘$/,
      /^파트너 프로그램에서 누리는 이점이 뭐야$/,
      /^파트너가 되면 무슨 좋은 점 있어$/,
      /^파트너 프로그램 혜택 알려줘$/,
    ],
    keywords: ['파트너 혜택', '이점', '지원', '마케팅', '우선 노출'],
    response: "파트너로 선정된 크리에이터는 다음과 같은 다양한 혜택을 누릴 수 있습니다:\n\n1. **스토어 내 우선 노출**: 파트너의 콘텐츠는 스토어의 메인 페이지와 인기 카테고리에서 특별히 강조되어 노출됩니다. 또한, 맞춤형 추천 시스템을 통해 더 많은 사용자에게 노출됩니다.\n\n2. **마케팅 및 홍보 지원**: CREAIT는 파트너의 콘텐츠를 홍보하기 위해 소셜 미디어, 이메일 뉴스레터, 공식 블로그 등 다양한 채널을 활용하여 마케팅 캠페인을 진행합니다. 또한, 특별 이벤트나 프로모션을 통해 파트너의 콘텐츠에 대한 인지도를 높입니다.\n\n3. **수수료 혜택**: 파트너는 일반 크리에이터보다 유리한 수수료 구조를 적용받습니다. 기본 6%의 수수료부터, 우수 파트너는 5%까지 혜택을 받을 수 있습니다.\n\n4. **콘텐츠 업데이트 및 피드백 지원**: CREAIT는 파트너가 자신의 콘텐츠를 지속적으로 개선할 수 있도록 정기적인 피드백을 제공합니다. 또한, 전문가 상담 서비스를 통해 콘텐츠 개발에 대한 지원을 받을 수 있습니다.\n\n5. **전문 워크샵 및 네트워킹 기회**: CREAIT가 주최하는 워크샵에 참여하여 업계 전문가와 네트워킹을 할 수 있으며, 다양한 교육 프로그램을 통해 전문성을 향상시킬 수 있습니다.\n\n6. **특별 배지 및 파트너 인증**: 파트너 크리에이터에게 부여되는 특별 배지는 프로필과 콘텐츠에 표시되어 사용자들에게 신뢰를 줄 수 있습니다.\n\n7. **기술 지원 및 우선 문의 처리**: 파트너는 우선적인 기술 지원을 받아 문제 발생 시 신속하게 해결할 수 있습니다.",
  },

  // 3. 파트너 심사 절차
  {
    id: 'partner_evaluation_procedure',
    patterns: [
      /^파트너 심사 절차가 어떻게 돼$/,
      /^파트너 선정 과정 설명해줘$/,
      /^파트너 심사 단계가 뭐야$/,
      /^CREAIT 파트너 심사 절차 알려줘$/,
      /^파트너 프로그램 심사 과정이 어떤가요$/,
      /^파트너 심사 단계 알려줘$/,
    ],
    keywords: ['파트너 심사', '선정 절차', '심사 단계', '프로그램 심사'],
    response: "파트너 프로그램에 지원하거나 추천된 크리에이터는 다음과 같은 단계별 심사를 통해 선정됩니다:\n\n1. **2차 평가: CREAIT 팀의 수동 심사**\n   - **콘텐츠 품질 심사**: CREAIT의 내부 전문가들이 크리에이터가 제공한 콘텐츠를 심층적으로 검토합니다. 콘텐츠의 기술적 완성도, 독창성, 디자인, 사용자 경험 등을 평가합니다.\n   - **사용자 피드백 및 평점 분석**: 크리에이터의 콘텐츠에 대한 사용자 리뷰와 평점을 면밀히 분석합니다. 긍정적인 리뷰와 높은 평점은 콘텐츠의 신뢰성과 인기를 반영합니다.\n   - **커뮤니티 활동 평가**: CREAIT 커뮤니티 내에서의 크리에이터의 활동 내역을 검토합니다. 상호 작용 및 기여도를 평가합니다.\n\n2. **3차 심사: 최종 인터뷰 및 협의**\n   - **크리에이터 인터뷰**: 필요시, CREAIT 팀은 크리에이터와 직접 인터뷰를 진행하여 제작 철학과 목표를 확인합니다.\n   - **파트너 역할에 대한 논의**: 파트너로서의 책임과 혜택을 명확히 이해하고 있는지 확인합니다.\n\n3. **최종 심사: 내부 평가 회의**\n   - **최종 결정**: 모든 평가가 완료된 후, CREAIT 내부 팀은 최종적으로 크리에이터가 파트너 자격에 적합한지 논의합니다.\n   - **파트너 자격 부여**: 최종 심사에서 긍정적인 평가를 받은 크리에이터는 공식적으로 CREAIT 파트너로 선정됩니다.\n\n4. **파트너 계약 체결 및 혜택 적용**\n   - **파트너 계약 체결**: 파트너 자격이 승인되면 계약이 체결됩니다.\n   - **혜택 활성화**: 계약 체결 후, 파트너 혜택이 즉시 활성화됩니다.",
  },

  // 4. 파트너 자격 유지 및 재평가
  {
    id: 'partner_maintenance_revaluation',
    patterns: [
      /^파트너 자격 유지 방법이 뭐야$/,
      /^파트너 등급을 유지하려면 어떻게 해야 해$/,
      /^파트너 자격을 지속하려면 어떻게 해야겠어$/,
      /^파트너로 남기 위해 필요한 조건은 뭐야$/,
      /^파트너 등급을 유지하려면 어떤 걸 해야 해$/,
      /^CREAIT 파트너 자격 유지 방법 알려줘$/,
    ],
    keywords: ['파트너 자격 유지', '등급 유지', '재평가', '조건'],
    response: "파트너로 선정된 후에도 정기적인 평가가 이루어지며, 기준을 충족하지 못하는 경우 등급이 하락할 수 있습니다. 크리에이터는 다음과 같은 조건을 지속적으로 충족해야 파트너 자격을 유지할 수 있습니다:\n\n1. **콘텐츠 품질 유지 및 개선**: 지속적으로 콘텐츠의 품질을 높이고, 사용자 피드백을 반영하여 개선해야 합니다.\n2. **판매 실적 유지**: 일정 기간 동안 꾸준한 판매 실적을 유지해야 합니다.\n3. **커뮤니티 기여도**: 커뮤니티 내에서 적극적으로 활동하고, 다른 크리에이터 및 사용자와의 상호작용을 유지해야 합니다.\n4. **정기적인 업데이트**: 콘텐츠의 지속적인 업데이트와 유지 관리를 통해 사용자 만족도를 높여야 합니다.\n5. **법적 및 윤리적 준수**: 저작권 및 지적 재산권을 준수하고, CREAIT의 커뮤니티 가이드라인을 지속적으로 준수해야 합니다.\n\n파트너 등급은 정기적인 평가를 통해 점수가 기준에 미달하는 경우 등급이 하락할 수 있습니다. 따라서, 크리에이터는 지속적으로 품질 높은 콘텐츠를 제공하고, 커뮤니티에 기여하는 활동을 유지해야 합니다.",
  },

  // 5. 파트너 프로그램 등급 시스템 점수표
  {
    id: 'partner_scoring_system',
    patterns: [
      /^CREAIT 파트너 프로그램 점수표 설명해줘$/,
      /^파트너 프로그램 점수체계 알려줘$/,
      /^CREAIT 파트너 점수표가 어떻게 돼$/,
      /^파트너 프로그램 평가 점수표 설명 부탁해$/,
      /^파트너 프로그램 점수표 내용 알려줘$/,
      /^파트너 점수표 설명해줘$/,
    ],
    keywords: ['점수표', '스크리닝', '평가', '점수체계'],
    response: "CREAIT 파트너 프로그램의 평가 점수표는 다음과 같습니다:\n\n**1. 콘텐츠 품질 (총 60점)**\n   - **독창성 및 차별화 요소**: 0 - 20점 - 콘텐츠의 창의성과 차별화 정도 평가\n   - **기술적 완성도**: 0 - 20점 - 오류 여부 및 기능 구현 완성도 평가\n   - **비주얼 및 사용자 경험**: 0 - 20점 - 디자인 품질 및 사용자 경험 평가\n\n**2. 판매 실적 (총 40점)**\n   - **판매량**: 0 - 20점 - 일정 기간 동안의 판매 실적 기반 평가\n   - **재구매율**: 0 - 10점 - 사용자 재구매 비율에 따른 평가\n   - **사용자 만족도**: 0 - 10점 - 사용자 리뷰 평점 기반 평가\n\n**3. 커뮤니티 기여도 (총 30점)**\n   - **활동성 및 상호작용**: 0 - 15점 - 커뮤니티 내 활동 및 사용자 상호작용 정도 평가\n   - **지원 및 기여도**: 0 - 15점 - 다른 크리에이터와의 협력 및 도움 정도 평가\n\n**4. 업데이트 및 유지 관리 (총 25점)**\n   - **콘텐츠 개선**: 0 - 15점 - 업데이트 빈도 및 사용자 피드백 반영 정도 평가\n   - **장기적인 로드맵**: 0 - 10점 - 향후 개선 및 개발 계획의 구체성 평가\n\n**5. 외부 활동 및 영향력 (총 20점)**\n   - **외부 플랫폼 홍보**: 0 - 10점 - 소셜 미디어 등에서의 활동 및 영향력 평가\n   - **콘텐츠 외부 사용**: 0 - 10점 - 타 플랫폼에서의 콘텐츠 사용 및 인지도 평가\n\n**6. 법적 및 윤리적 기준 준수 (총 30점)**\n   - **저작권 및 지적 재산권 준수**: 0 - 15점 - 지적 재산권을 존중하는 정도 평가\n   - **커뮤니티 가이드라인 준수**: 0 - 15점 - 커뮤니티 내에서의 행동 기준 준수 평가\n\n**총 점수: /250점**\n\n**평가 및 선정 기준**:\n- **70점 이하**: 파트너 자격 없음\n- **71-150점**: 추가 개선 필요, 재심사 가능\n- **151-200점**: 파트너 자격 부여 가능\n- **201점 이상**: 우수 파트너 자격 부여",
  },

  // 6. 파트너 프로그램 등급 시스템
  {
    id: 'partner_grade_system',
    patterns: [
      /^CREAIT 파트너 프로그램 등급 시스템이 뭐야$/,
      /^파트너 등급 시스템 설명해줘$/,
      /^CREAIT 파트너 등급이 어떻게 돼$/,
      /^파트너 등급 별 시스템 알려줘$/,
      /^CREAIT 파트너 등급 체계 설명$/,
      /^파트너 등급 시스템 상세히 알려줘$/,
    ],
    keywords: ['파트너 등급', '등급 시스템', '체계', '등급 분류'],
    response: "CREAIT 파트너 프로그램은 크리에이터의 활동 수준에 따라 다음과 같은 등급으로 구분됩니다:\n\n1. **파트너 (Basic Partner)**\n   - **자격 요건**: 기본적인 파트너 기준을 충족하며, 최소 150점을 기록한 크리에이터.\n   - **주요 혜택**:\n     - 스토어 내 일반적인 콘텐츠 노출 혜택.\n     - 기본적인 마케팅 지원 및 CREAIT 소식지에 이름 소개.\n     - 표준 수수료 최대 혜택 적용 (6%).\n     - 콘텐츠 업데이트 및 피드백 지원.\n     - 기본 기술 지원 제공.\n\n2. **우수 파트너 (Premium Partner)**\n   - **자격 요건**: 최소 200점을 기록하고, 판매 실적 및 커뮤니티 기여도가 우수한 크리에이터.\n   - **주요 혜택**:\n     - 스토어 내 우선 노출 혜택 (메인 페이지 또는 인기 카테고리).\n     - 강화된 마케팅 및 홍보 캠페인 지원.\n     - 수수료 혜택 (5%).\n     - 콘텐츠 개선 및 유지 관리에 대한 전문가 상담 서비스.\n     - 특별 배지 및 파트너 인증 마크 부여.\n     - 전문 워크샵 및 네트워킹 이벤트 무료 참가 기회.\n     - 신속한 기술 지원 및 우선적인 문의 처리.\n\n3. **최고 파트너 (Elite Partner)**\n   - **자격 요건**: 최소 250점을 기록하고, 장기간에 걸쳐 뛰어난 성과를 보여준 크리에이터.\n   - **주요 혜택**:\n     - 스토어 내 프리미엄 우선 노출 혜택.\n     - 맞춤형 마케팅 전략 지원 및 CREAIT의 모든 홍보 채널을 통한 집중 홍보.\n     - 수수료 혜택 (5%).\n     - 정기적인 1:1 전문가 피드백 및 콘텐츠 개선 지원.\n     - 고급 기술 지원 및 문제 발생 시 우선 처리.\n     - 모든 CREAIT 이벤트 무료 참가 및 VIP 초청.\n     - 전담 고객 관리 서비스 제공.",
  },

  // 기본 응답 (마지막에 위치하여 모든 패턴에 매칭되지 않는 경우)
  {
    id: 'default_response',
    patterns: [
      /.*/, // 모든 입력에 매칭
    ],
    response: "죄송합니다. 요청하신 내용을 이해하지 못했습니다. 다른 질문을 해주시겠어요?",
  },
];